import React, { useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import API_BASE_URL from "../../config/Api";
import { AuthContext } from "../../context/AuthContext";
import { PERMISSIONS } from "../../config/permissions";

import CardWrapper from "../../components/CardLogin";
import { showToast } from "../../components/Toast";

const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);

    const { login } = useContext(AuthContext);
    const navigate = useNavigate();
    const location = useLocation();

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (loading) return;
        setLoading(true);

        try {
            const response = await API_BASE_URL.post("/auth/login", {
                email: email.trim(),
                password,
            });
            const loginData = response.data;

            if (!loginData || typeof loginData !== "object" || !loginData.token || !loginData.email || !loginData.id) {
                throw new Error("INVALID_LOGIN_RESPONSE");
            }

            const userData = {
                Id: loginData.id,
                email: loginData.email,
                permissions: Array.isArray(loginData.permissions) ? loginData.permissions : [],
            };

            login(userData, loginData.token);
            setEmail("");
            setPassword("");

            const from = location.state?.from;
            const returnPath = from?.pathname;
            const isGeneralDirectionManager = userData.permissions.some((permission) =>
                String(permission).toUpperCase() === PERMISSIONS.DG_MANAGER);
            const destination = isGeneralDirectionManager
                ? "/dashboard"
                : returnPath?.startsWith("/") && !returnPath.startsWith("//") && returnPath !== "/login"
                    ? { pathname: returnPath, search: from.search || "", hash: from.hash || "" }
                    : "/dashboard";
            navigate(destination, { replace: true });

            showToast({
                title: "Notification",
                message: "Connexion reussie. Bienvenue dans le systeme.",
                type: "success",
            });
        } catch (err) {
            const status = err?.response?.status;
            const message = err.message === "INVALID_LOGIN_RESPONSE"
                ? "Reponse de connexion invalide. Veuillez reessayer."
                : !err?.response
                ? "Serveur inaccessible. Verifiez la connexion au VPS puis reessayez."
                : status >= 500
                    ? "Serveur momentanement indisponible. Veuillez reessayer."
                    : "Email incorrect ou mot de passe incorrect. Veuillez reessayer.";

            showToast({
                title: "Erreur",
                message,
                type: "error",
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <CardWrapper>
            <form className="soma-mco-auth-form" onSubmit={handleSubmit}>
                <label className="soma-mco-field" htmlFor="email">
                    <span className="soma-mco-field-label">Adresse e-mail</span>
                    <span className="soma-mco-input-wrap">
                        <i className="bx bx-user"></i>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            placeholder="nom@entreprise.com"
                            autoComplete="email"
                            value={email}
                            required
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </span>
                </label>

                <label className="soma-mco-field" htmlFor="password">
                    <span className="soma-mco-field-label">Mot de passe</span>
                    <span className="soma-mco-input-wrap">
                        <i className="bx bx-lock-alt"></i>
                        <input
                            type={showPassword ? "text" : "password"}
                            id="password"
                            name="password"
                            placeholder="Votre mot de passe"
                            autoComplete="current-password"
                            value={password}
                            required
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        <button
                            type="button"
                            className="soma-mco-password-toggle"
                            onClick={() => setShowPassword((current) => !current)}
                            aria-label={showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
                        >
                            <i className={`bx ${showPassword ? "bx-hide" : "bx-show"}`}></i>
                        </button>
                    </span>
                </label>

                <button className="soma-mco-auth-submit" type="submit" disabled={loading}>
                    {loading && <span className="soma-mco-auth-spinner" aria-hidden="true"></span>}
                    {loading ? "Connexion en cours..." : "Se connecter"}
                </button>
            </form>
        </CardWrapper>
    );
};

export default Login;
